export default __webpack_public_path__ + "static/media/chevron-down.47c12799.svg";